import { render } from "./VideoWallPageLayout.vue?vue&type=template&id=4d0fc605&ts=true"
import script from "./VideoWallPageLayout.vue?vue&type=script&lang=ts"
export * from "./VideoWallPageLayout.vue?vue&type=script&lang=ts"

import "./VideoWallPageLayout.vue?vue&type=style&index=0&id=4d0fc605&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__